import { useEffect } from 'react'
import { defaultTo, find, path, pipe, propEq } from 'ramda'

import { Plan } from '@/types'
import { RootState, useDispatch, useSelector } from '@/lib/redux'
import useCurrentSession from '@/hooks/use-current-session'

type PlanTuple = {
  active?: Plan
  next?: Plan
  loading?: boolean
}

type Return = Plan | undefined

type State = 'ACTIVE' | 'PENDING'

const getByState = (state: State) =>
  pipe<RootState, Plan[] | undefined, Plan[], Return>(
    path(['plans', 'plans']),
    defaultTo([]),
    find<Plan>(propEq('state', state))
  )

const useActivePlan = (): PlanTuple => {
  const dispatch = useDispatch()
  const profile = useCurrentSession()
  const loggedIn = !!profile?.user_type
  const loaded = useSelector(path(['plans', 'plans_loaded']))
  const loading = !loaded
  const active = useSelector(getByState('ACTIVE'))
  const next = useSelector(getByState('PENDING'))
  useEffect(() => {
    if (!loggedIn) return
    dispatch.plans.load()
  }, [dispatch.plans, loggedIn])
  return { active, next, loading }
}

export default useActivePlan
